module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/vip-icons-02-fe6c90937013b526d7abe59487704c62.png";